import { useTranslation } from 'react-i18next'
import React from 'react'
import { Col, Grid } from '../../../../../packages/kiti/components/structure/Grid'
import { SmallText } from '../../../../../packages/kiti/components/presentation/Text'
import FormItem from '../../../../../packages/kiti/components/form/form/FormItem'
import NumberInput from '../../../../../packages/kiti/components/form/NumberInput'
import Separator from '../../../../../packages/kiti/components/helpers/Separator'
import SlaTypeSelect from '../../../../../containers/serviceOrders/select/SlaTypeSelect'
import SlaValueSelect from '../../../../../containers/serviceOrders/select/SlaValueSelect'
import Icon from '../../../../../packages/kiti/components/shapes/Icon'
import PlaceSelect from '../../../../../containers/places/select/PlaceSelect'
import ChecklistSelect from '../../../../../containers/checklists/select/ChecklistSelect'
import { usePlacesLoader } from '../../../../../containers/places/select/PlaceSelect'
import { useFormState } from '../../../../../packages/kiti/components/form/form/FormHandler'

const GeneralSection = () => {
  const { t } = useTranslation('editSla')
  const { handleChangeIn } = useFormState()
  const [loadingAllPlaces, setLoadingAllPlaces] = React.useState(false)
  // `cleanWhenEnabledFilterIsSet` only recognizes `enabled` as the string 'true'/'false'
  // (it comes from filter-bar dropdowns elsewhere). Passing the boolean `true` here was
  // silently coerced to `enabled: false`, so "select all" fetched disabled places instead
  // of the active ones shown in the dropdown. Omitting the filter relies on the backend's
  // own default (`enabled: true`), matching exactly what the dropdown already lists.
  const loadPlaces = usePlacesLoader({})

  const handleLoadPlaces = async () => {
    setLoadingAllPlaces(true)
    const limit = 999999
    const page = 1
    const search = ''
    const places = await loadPlaces(search, page, limit)
    setLoadingAllPlaces(false)
    return places
  }

  const handleSelectAllPlaces = async () => {
    const places = await handleLoadPlaces()
    handleChangeIn(['value', 'places'], places)
  }

  return (
    <>
      <Grid paddingGutter={0.5} align="center" wrap>
        <Col width="100%">
          <FormItem
            label={t('checklist')}
            path={['value', 'checklists']}
            Input={ChecklistSelect}
            filter={{ usages: ['serviceOrder'], includeDisabled: false }}
            canCreate
            placeholder="Selecione"
            multiple
          />
        </Col>
        <Col width="100%">
          <FormItem
            label={t('place')}
            path={['value', 'places']}
            canCreate
            Input={PlaceSelect}
            placeholder="Selecione"
            multiple
            onSelectAll={handleSelectAllPlaces}
            hasSelectAll
            loading={loadingAllPlaces}
          />
        </Col>
        <Col width="100%">
          <FormItem
            label={t('startCount')}
            path={['value', 'sla_type']}
            Input={SlaTypeSelect}
            returnObject
            placeholder="Selecione"
          />
        </Col>
        <Col width="50%">
          <FormItem
            label={t('unit')}
            path={['value', 'sla_unit']}
            Input={SlaValueSelect}
            returnObject
            placeholder="Selecione"
          />
        </Col>
        <Col width="50%">
          <FormItem
            label={t('slaValue')}
            path={['value', 'sla_value']}
            Input={NumberInput}
            min={1}
            max={9999}
            placeholder="Ex: 12"
          />
        </Col>
        <Col width="100%">
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px' }}>
            <Icon name="BsExclamationCircleFill" color="#FFC107" size={1.5} />
            <SmallText>{t('warning')}</SmallText>
          </div>
        </Col>
      </Grid>
      <Separator weight={2} />
    </>
  )
}

export default GeneralSection
